import { useMemo, useCallback } from 'react';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import useBookCollection from './useBookCollection';

const useBookAvailabilityCheck = (defaultBookId = null, defaultContentType = 'content') => {
  const alertMessage = useAlert();
  const { nonAssignableBookIds = [], hiddenBookGroupBookId = [], hiddenBookId = [] } = useBookCollection();

  const checkBookAvailability = useCallback((bookId = defaultBookId, contentType = defaultContentType) => {
    if (!bookId) return true;
    
    const bookIdNumber = Number(bookId);
    const isBookNotAssignable = nonAssignableBookIds?.includes(bookIdNumber);
    const isBookHidden = hiddenBookId?.includes(bookIdNumber) || hiddenBookGroupBookId?.includes(bookIdNumber);
    
    if (isBookNotAssignable) {
      alertMessage(`Book is not available for students, ${contentType} cannot be shared`, "info");
      return false;
    } else if (isBookHidden) {
      alertMessage(`Book is hidden, ${contentType} cannot be shared`, "info");
      return false;
    }
    return true;
  }, [defaultBookId, defaultContentType, nonAssignableBookIds, hiddenBookGroupBookId, hiddenBookId, alertMessage]);

  return checkBookAvailability;
};

export default useBookAvailabilityCheck;

